import { inject } from '@angular/core';
import { ResolveFn, RedirectCommand, Router } from '@angular/router';
import { GlobalStateService } from '../state/global-state.service';
import { buildLoginRedirectUrl } from '../utils/url-utils';

type Saml2ResolveResult = string | RedirectCommand;

export const Saml2TokenResolver: ResolveFn<Saml2ResolveResult> = async (route, state) => {
    // Section: SERVICES
    //----------------------------------------------------------------------
    const globalState = inject(GlobalStateService);
    const router = inject(Router);

    // Section: PRIVATE METHODS
    //----------------------------------------------------------------------
    const handleLoginFailure = (): RedirectCommand => {
        globalState.setExternalLoginFailed(true);

        const companyCodeFromStorage = localStorage.getItem('lastUserLoginBrand');
        const loginUrl = buildLoginRedirectUrl('/', companyCodeFromStorage);
        return new RedirectCommand(router.parseUrl(loginUrl));
    };

    // Section: PUBLIC METHODS
    //----------------------------------------------------------------------
    const accessToken = route.queryParamMap.get('access_token');

    if (accessToken) {
        localStorage.setItem('accessToken', accessToken);
        return accessToken;
    }
    return handleLoginFailure();
};
